<template>
  <!--srccomponentsgui_scroll_xgui_scroll_xvuehtmlStart-->

  <div id="defaultId1">
    <div id="idk1z9qS" class="scroll-container" ref="container">
      <div id="id8RMA9z" class="scroll-content" ref="content">
        <div id="idwcmjvI" class="scroll-content-box">
          <slot id="idbHp7NR"> </slot>
        </div>
      </div>
      <button
        id="idHWVxE3"
        @click="scrollLeft"
        class="prev scroll-btn"
        :disabled="scrollLeftDisabled"
      >
        <i class="icon iconfont icon-jiantouzuo"></i>
      </button>
      <button
        id="idgqE5ZX"
        @click="scrollRight"
        class="scroll-btn next"
        :disabled="scrollRightDisabled"
      >
        <i class="icon iconfont icon-jiantouyou"></i>
      </button>
    </div>
  </div>
  <!--srccomponentsgui_scroll_xgui_scroll_xvuehtmlEnd-->
</template>

<script>
function waitForScrollEnd(callback, delay) {
  let timeout;
  window.addEventListener("scroll", function onScroll() {
    clearTimeout(timeout);
    timeout = setTimeout(function () {
      window.removeEventListener("scroll", onScroll);
      callback();
    }, delay);
  });
}

// interfaceCode
export default {
  name: "HorizontalScroll",
  data() {
    return {
      contentWidth: 0,
      scrollLeftDisabled: true,
      checkScrollTime: "",
      scrollRightDisabled: true,
    };
  },
  methods: {
    checkScroll() {
      const container = this.$refs.content;
      const content = this.$refs.content.children[0];

      this.scrollLeftDisabled = container.scrollLeft === 0;
      this.scrollRightDisabled =
        container.scrollLeft + container.offsetWidth >= content.scrollWidth;
    }, // scrollLeft
    scrollLeft() {
      const container = this.$refs.content;
      container.scrollBy({
        left: -100,
        behavior: "smooth",
      });
      // 等待滚动结束后执行操作

      if (this.checkScrollTime) {
        clearTimeout(this.checkScrollTime);
        this.checkScrollTime = null;
      }
      this.checkScrollTime = setTimeout(() => {
        this.checkScroll();
      }, 800);
    }, // scrollRight
    async scrollRight() {
      const container = this.$refs.content;
      container.scrollBy({
        left: 100,
        behavior: "smooth",
      });
      if (this.checkScrollTime) {
        clearTimeout(this.checkScrollTime);
        this.checkScrollTime = null;
      }
      this.checkScrollTime = setTimeout(() => {
        this.checkScroll();
      }, 800);
    },
  },
  mounted() {
    const content = this.$refs.content;
    this.contentWidth = content.scrollWidth;
    this.checkScroll();
  },
  updated() {
    this.checkScroll();
  },

  props: {},
  components: {},
};
</script>

<style>
.scroll-container {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  position: relative;
  overflow-x: hidden;
}

.scroll-content {
  width: calc(100% - 80px);
  overflow-x: auto;
  scrollbar-width: none;
  scroll-snap-type: x mandatory;
  margin-left: 40px;
}

.scroll-content-box {
  width: max-content;
  display: flex;
  scrollbar-width: none;
}

.scroll-btn {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 26px;
  height: 26px;
  position: absolute;
  top: 0;
  bottom: 0;
  background-color: #ffffff;
  color: #1290c9;
  border: none;
  outline: none;
  cursor: pointer;
  transition: opacity 0.3s;
  border-bottom-left-radius: 100em;
  border-top-left-radius: 100em;
  border-top-right-radius: 100em;
  border-bottom-right-radius: 100em;
  margin-top: 4px;
}

.next {
  right: 0;
}
.scroll-content::-webkit-scrollbar {
  display: none;
}
.scroll-btn {
  color: #1290c9;
  background: rgba(255, 255, 255, 1);
}
.leads_layout .scroll-btn {
  color: #8e86dd;
}
.scroll-btn:disabled {
  color: #fff;
  cursor: not-allowed !important;
  background: rgba(255, 255, 255, 0.16);
}
.scroll-btn:disabled i {
  cursor: not-allowed !important;
}
@media (max-width: 1920px) {
  .scroll-btn {
    width: 20px;
    height: 20px;
    margin-top: 4px;
  }
}
@media (max-width: 1439px) {
}
</style>
